export default __webpack_public_path__ + "static/media/trr-drink-cocktail-millennialmilieu.7220ea02.png";